export { NavigateBack } from './lib/NavigateBack';
export { RegisterRouterService } from './lib/RegisterRouterService';
export { registerRoute, route, Route, Switch } from './lib/route';
